import { SetStoreClassesMutation } from "~/gql/mutations/storeClass.generated";
import { GetStoreClassesQuery } from "~/gql/queries/storeClass.generated";

export const storeClassEndpoints = {
	GetStoreClasses: {
		providesTags: ["StoreClasses"] as AddTagTypes,
		transformResponse: (res: GetStoreClassesQuery) => res
	},
	SetStoreClasses: {
		invalidatesTags: ["StoreClasses"] as AddTagTypes,
		transformResponse: (res: SetStoreClassesMutation) => res
	}
};
